import type { IconData } from '@stacksjs/iconify-core'

export const virusAntivirus: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M14.375 24a9.625 9.625 0 1 0 19.25 0a9.625 9.625 0 1 0-19.25 0\"/><path d=\"M24 10v4.375M24 38v-4.375M33.9 14.1l-3.093 3.094M14.1 33.9l3.093-3.094M38 24h-4.375M10 24h4.375M33.9 33.9l-3.093-3.094M14.1 14.1l3.093 3.094\"/><path stroke-linejoin=\"round\" d=\"M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21s21-9.402 21-21S35.598 3 24 3M9.5 9.5l29 29\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default virusAntivirus
